import { useState, useContext } from "react";
import { firestore } from "../../../../firebaseInit";
import {
  collection,
  where,
  query,
  onSnapshot,
  orderBy,
} from "firebase/firestore";
import { LoadingContext } from "../../../../contexts/LoadingContext";

// global for listener object, when active
let unsub = null;

const useLearnerNarrativesDialog = () => {
  const { setIsLoading } = useContext(LoadingContext);
  const [narratives, setNarratives] = useState(null);

  // creates listener for the learners narratives
  const establishNarrativesListener = (learnerId, sectionId) => {
    setIsLoading(true);

    const q = query(
      collection(firestore, "narratives"),
      where("learnerId", "==", learnerId),
      where("sectionId", "==", sectionId),
      orderBy("isPublished", "asc"),
      orderBy("createdOn", "desc")
    );

    unsub = onSnapshot(q, (querySnapshot) => {
      const fetchedNarratives = [];

      querySnapshot.forEach((doc) => {
        fetchedNarratives.push({ id: doc.id, ...doc.data() });
      });

      setNarratives(fetchedNarratives);

      setIsLoading(false);
    });
  };

  const unloadListener = () => {
    if (unsub) {
      unsub();
    }
  };

  return {
    establishNarrativesListener,
    narratives,
    unloadListener,
  };
};

export default useLearnerNarrativesDialog;
